export const availableRoles = {
  Ventanero: "ventanero",
  Callcenter: "callcenter",
  Coordinador: "coordinador",
  "Coordinador Cos": "coordinador_cos",
  Administrador: "admin",
  Rotación: "rotacion",
  "Nuevo Rotación": "new_rotacion",
};
